import loadable from '@loadable/component';

export const AsyncMap = loadable(
    () =>
        import(
            /* webpackChunkName: "popular-destinations-map" */
            /* webpackPrefetch: true */
            './Map'
        ),
    {ssr: false}
);

AsyncMap.displayName = 'AsyncMap';
